export default __webpack_public_path__ + "assets/b86c771ad24513acad2c5d0de57564be.svg";